const NepaliDate = require('nepali-date-js');
const nd = new NepaliDate();

export default {
    filter_date: {
        from_date: nd.format('YYYY-MM-DD'),
        to_date: nd.format('YYYY-MM-DD')
    }
};
